<ng-container *ngIf="plusCardData$ | async as plusCardData">
  <div #plusCard class="plus-card relative" [style.fontSize.px]="fontSize$ | async" data-testid="plus-card">
    <div class="absolute top-left fill grow">
      <div
        [ngClass]="{ 'white-text': !plusCardData.isStartingTier }"
        class="content absolute fill grow flex flex--column white-text"
      >
        <!--
		Apparently the dynamic labels could be directly modified in the SVG, which could really simplify this component.
		Just not sure about the multiline member name with ellipsis, but if you read this and have the time, try doing that.
	-->
        <div class="align-center light-type">
          <span class="plus-card-tier-name" data-testid="card-tier-full-name">{{ plusCardData.cardTierFullName }}</span>
          <br />
          <span class="plus-card-member-number" data-testid="member-number-formatted">{{
            plusCardData.memberNumberFormatted
          }}</span>
        </div>
        <div class="plus-card-member-name flex flex-1 flex--align-end">
          <span class="overflow-hidden">{{ plusCardData.firstName + ' ' + plusCardData.lastName }}</span>
        </div>
      </div>

      <div class="logos absolute fill flex flex--end" data-testid="logos">
        <div *ngIf="aviosLogo$ | async as aviosLogo" class="avios-logo">
          <fcom-image [imageData]="aviosLogo" [scale]="false" [ratio]="'ORIGINAL'" [alt]="aviosLogo.alt" />
        </div>
        <div *ngIf="oneworldLogo$ | async as oneworldLogo" class="oneworld-logo">
          <fcom-image [imageData]="oneworldLogo" [scale]="false" [ratio]="'ORIGINAL'" [alt]="oneworldLogo.alt" />
        </div>
      </div>

      <fcom-icon
        [category]="IconLibrary.CUSTOM"
        [dataTestId]="'plus-card-bg'"
        [name]="TIER_DATA_MAP[plusCardData.cardTier]?.cardIcon"
      />
    </div>
  </div>
  <span
    class="block font-body-1 grey-500-text regular-type ms-small-t"
    *ngIf="showCardExpirationDateIfApplicable && !plusCardData.isStartingTier && !plusCardData.cardLifetimeTierFlag"
    data-testid="card-expiration-date"
    >{{ 'plus.dashboard.expires' | finLocalization }}
    {{ plusCardData.cardExpirationDate | finDateFormat: 'DATE' }}
  </span>
</ng-container>
